module.exports = __webpack_public_path__ + "static/media/brtlogo.cd025e7d.png";